import { wordKey } from "./wordKey";

// Words that cannot be part of a place name, so what follows the last one is the place being typed.
// "of", "the" and "a" are left out: names contain them ("District of Columbia").
const PLACE_BREAK_WORDS = new Set([
  "in", "at", "on", "near", "within", "from", "to", "for", "by", "among", "between", "with",
  "and", "or", "than", "versus", "vs", "as", "is", "are", "was", "were", "be",
  "who", "whom", "which", "that", "where", "what", "how", "many",
  "show", "me", "compare", "voters", "voter", "voted", "people",
]);
const INNER_ONLY_WORDS = new Set(["of", "the", "a", "an"]);
// "Lake of the Woods County", the longest name in the data.
const MAX_PLACE_WORDS = 5;

// The place being typed: the words after the last one that cannot be part of a place (a number
// also ends it), minus a leading "of"/"the".
export function placeFragmentOf(text, maxWords = MAX_PLACE_WORDS) {
  const words = (text || "").trim().split(/\s+/).filter(Boolean);
  const afterBreak = words
    .slice(words.findLastIndex((w) => PLACE_BREAK_WORDS.has(wordKey(w)) || /\d/.test(w)) + 1)
    .slice(-maxWords);
  const start = afterBreak.findIndex((w) => !INNER_ONLY_WORDS.has(wordKey(w)));
  return start === -1 ? "" : afterBreak.slice(start).join(" ");
}
